<nav class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-menu">
    <div class="navbar-start">
      <a
        href="/#/"
        class="navbar-item footer-item"
        class:is-active={activateFloodLikelihoodBtn}
        on:click|preventDefault={toggleActive(Buttons.FloodLikelihood)}>
        <div class="icon-container" class:is-tour={isTourLikelihood}>
          <img class="icon" alt="Flood Likelihood" src={iconFloodLikelihood} />
        </div>
        Flood Likelihood
      </a>

      <a
        href="/#/"
        class="navbar-item footer-item"
        class:is-active={activateRiskProfileBtn}
        on:click|preventDefault={toggleActive(Buttons.RiskProfile)}>
        <div class="icon-container" class:is-tour={isTourRisk}>
          <img class="icon" alt="Risk Profile" src={iconRiskProfile} />
        </div>
        Risk Profile
      </a>
    </div>
  </div>

  <slot />
</nav>


<script>
import IconFloodLikelihood from "./../../assets/images/floodslikelihood.svg";
import IconRiskProfile from "./../../assets/images/riskprofile.svg";
import store, { STATES_START, STATES_MAIN, STATES_TOUR } from "../../state";
import { pathOr } from "ramda";
var Buttons;
(function (Buttons) {
    Buttons[Buttons["FloodLikelihood"] = 0] = "FloodLikelihood";
    Buttons[Buttons["RiskProfile"] = 1] = "RiskProfile";
})(Buttons || (Buttons = {}));
// html vars
let iconFloodLikelihood = IconFloodLikelihood;
let iconRiskProfile = IconRiskProfile;
let activateRiskProfileBtn = false;
let activateFloodLikelihoodBtn = false;
let isTourLikelihood = false;
let isTourRisk = false;
store.subscribe(state => {
    if (state.currentState.includes(`${STATES_MAIN.START}.${STATES_START.DEFAULT}`)) {
        activateRiskProfileBtn = false;
        activateFloodLikelihoodBtn = false;
        return;
    }
    activateFloodLikelihoodBtn = state.currentState.includes(`${STATES_MAIN.START}.${STATES_START.FLOOD_LIKELIHOOD}`);
    activateRiskProfileBtn = state.currentState.includes(`${STATES_MAIN.START}.${STATES_START.FLOOD_RISK}`);
    if (state.currentState.includes(`${STATES_MAIN.TOUR}.${STATES_TOUR.DEFAULT}`)) {
        const tourStep = pathOr(0, ["tourStep"], state);
        isTourLikelihood = tourStep === 1;
        isTourRisk = tourStep === 3;
    }
});
function toggleActive(btnType) {
    return (e) => {
        const defaultStateKey = `${STATES_MAIN.START}.${STATES_START.DEFAULT}`;
        switch (btnType) {
            case Buttons.FloodLikelihood:
                return store.update(state => {
                    const key = `${STATES_MAIN.START}.${STATES_START.FLOOD_LIKELIHOOD}`;
                    if (state.currentState === key)
                        state.currentState = defaultStateKey;
                    else
                        state.currentState = key;
                    return state;
                });
            case Buttons.RiskProfile:
                return store.update(state => {
                    const key = `${STATES_MAIN.START}.${STATES_START.FLOOD_RISK}`;
                    if (state.currentState === key)
                        state.currentState = defaultStateKey;
                    else
                        state.currentState = key;
                    return state;
                });
        }
    };
}
</script>


<style>.navbar{height:6.625rem;min-height:6.625rem;background-color:#1d3b78;margin-top:auto;pointer-events:auto;display:none}.navbar-menu{height:100%;background-color:inherit;margin:0;display:block;padding:.5rem 0 1rem}.navbar-start{display:flex;justify-content:center;flex:1}.navbar .footer-item{text-align:center;color:#fff;background:transparent;width:50%;padding:0;text-transform:uppercase;font-size:.75em;font-weight:700;display:flex;flex-direction:column}.navbar .footer-item .icon-container{height:4rem;width:4rem;border-radius:50%;margin:0 auto;display:flex;flex:0 0 4rem;transition:transform .24s cubic-bezier(.175,.885,.32,1.275)}.navbar .footer-item .icon-container .icon{margin:auto;transition:transform .24s cubic-bezier(.175,.885,.32,1.275) .06s}.navbar .footer-item .icon-container.is-tour{opacity:0}.navbar .footer-item.is-active .icon-container{background-color:#f08403;transform:translateY(-2rem)}.navbar .footer-item.is-active .icon-container .icon{transition-delay:.12s;transform:scale(1.5)}.navbar .footer-item.is-active,.navbar .footer-item:hover{background-color:inherit;color:#fff}@media screen and (max-width:1023px){.navbar{display:block;height:auto;width:100%;margin:0;position:fixed;bottom:0}}</style>
